import React from 'react';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'medium', 
  className = '' 
}) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  return (
    <div className={`${className} flex items-center justify-center`}>
      <div className={`animate-spin rounded-full border-t-transparent border-2 border-primary ${sizeClasses[size]}`} />
    </div>
  );
}; 